export const setMetaTheme = (color: string) => {
  const metaThemeColor = document.querySelector('meta[name=theme-color]')

  metaThemeColor?.setAttribute('content', color)
}
